import React from "react";
import * as R from "ramda";

import { Box, Flex, Link, Text } from "src/components";
import { Button } from "src/components/Form";
import { defaultPrevented } from "src/utils";

const Channel = ({ channel, onSelect, sending }) => (
  <Button
    key={channel.address}
    flexDirection="row"
    data-testid={channel.type}
    border="none"
    bg={sending ? "orangeTransparent" : "orange"}
    p={3}
    mt={1}
    flex={1}
    onClick={defaultPrevented(onSelect)}
    numeric={R.contains(channel.type, ["call", "text"])}
    subTitle={
      R.contains(channel.type, ["call", "text"]) && `as ${channel.type}`
    }
    title={channel.address}
    disabled={sending}
  />
);

const ChannelSelection = props => (
  <Flex p={2} flexDirection="column" data-testid={"channel-selection"}>
    {props.renderAboveChannelSelection
      ? props.renderAboveChannelSelection()
      : null}
    {props.availableChannels.map(channel => (
      <Channel
        key={channel.userChannelId}
        onSelect={() => props.onSelectChannel(channel)}
        sending={props.sending}
        channel={channel}
      />
    ))}
  </Flex>
);

export default ChannelSelection;



// WEBPACK FOOTER //
// ./src/banking/authentication/ChannelSelection.js